import {EmptyStatus} from 'platform/components';
import {Box, Stack} from 'platform/foundation';

import {useDispatch} from 'react-redux';

import {chatAgentApi, useSubscribeToChatConversationMutation} from '@dms/api/core';
import {useLazyGetBusinessCaseQuery} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {useBcToOnlineOffer} from '@dms/shared';

interface EmptyStateProps {
  businessCaseId: string;
}

export function EmptyState(props: EmptyStateProps) {
  const dispatch = useDispatch();
  const {canSendOffer, actions} = useBcToOnlineOffer(props.businessCaseId);
  const [refetchBusinessCase] = useLazyGetBusinessCaseQuery();
  const [subscribeToChatConversation] = useSubscribeToChatConversationMutation();

  const handleChatInvalidation = () => {
    setTimeout(async () => {
      const updatedBusinessCase = await refetchBusinessCase({businessCaseId: props.businessCaseId});
      // Subscribe to new active conversation if it exists
      const newActiveConversation = updatedBusinessCase.data?.chatConversations?.find(
        (conv) => conv.isActive
      );

      if (newActiveConversation?.conversationId) {
        try {
          await subscribeToChatConversation({
            conversationId: newActiveConversation.conversationId,
          }).unwrap();
        } catch (error) {
          console.error('Failed to subscribe to chat conversation:', error);
        }
      }

      await refetchBusinessCase({businessCaseId: props.businessCaseId});

      dispatch(chatAgentApi.util.invalidateTags(['ConversationEvents', 'Conversation']));
    }, 5000);
  };

  return (
    <Stack direction="column" height="100%" width="100%">
      <Box paddingTop={45}>
        <EmptyStatus
          variant="table"
          headline={i18n.t('entity.activityPanel.activity.noActivity')}
          subheadline={i18n.t('entity.activityPanel.activity.offerNotShared')}
          action={
            canSendOffer
              ? {
                  onClick: () =>
                    actions.sendOnlineOfferToCustomer({
                      shouldCreateOffer: true,
                      onSuccess: handleChatInvalidation,
                    }),
                  title: i18n.t('page.businessCase.actions.sendOnlineOffer'),
                  variant: 'secondary',
                }
              : undefined
          }
        />
      </Box>
    </Stack>
  );
}
